import { datadogRum } from '@datadog/browser-rum';
import { BaseUrls } from 'api';

export function initMonitoringTool() {
  if (window.location.host.includes('localhost')) {
    return;
  }

  datadogRum.init({
    applicationId: 'd26648c3-b83e-45d1-b995-4572e9666fbe',
    clientToken: 'pub526580a7a03f5971996c1dcba932ff93',
    site: 'datadoghq.eu',
    service: 'fp_hotel_web',
    env: BaseUrls.getEnv(),
    version: process.env.VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    trackViewsManually: true,
  });
}
